import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Contact from "./Contact";
import Whatsapp from "./util/Whatsapp";
import { Faixa, Cabecalho } from "./Faixa";
import { Destaque, fundosDosBlocos } from "./Blocos";
import { whatsappUrl } from "./util/whatsappUrl";
import { trackWhatsapp } from "./util/analytics";

const PaginaLocal = ({ local, blocos }) => {
  useEffect(() => {
    const anterior = document.title;
    document.title = local.titulo;
    return () => {
      document.title = anterior;
    };
  }, [local.titulo]);

  const fundos = fundosDosBlocos(blocos);
  const fundoFinal = fundos[fundos.length - 1];

  return (
    <>
      <Header />
      <main>
        <div className="bg-pattern-gradient pt-12 xl:pb-32">
          <div className="text-white w-3/4 mx-auto xl:pt-48 pt-24 pb-16 xl:text-center">
            <h1 className="text-4xl sm:text-5xl xl:text-6xl font-semibold leading-[1.1] mb-8 break-words hyphens-auto">
              <Destaque texto={local.h1} destaque={local.destaque} />
            </h1>
            <p className="text-xl xl:text-2xl leading-relaxed mb-10 xl:w-2/3 xl:mx-auto">{local.subtitulo}</p>
            <a
              href={whatsappUrl(local.mensagem)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsapp(`pagina${local.slug.replace(/\//g, "-")}`)}
              className="btn-glass font-semibold py-6 px-8 rounded-full block xl:inline-block text-xl text-center w-full xl:w-auto whitespace-nowrap"
            >
              Falar no WhatsApp
            </a>
          </div>
        </div>

        {blocos.map((bloco, indice) => (
          <Faixa key={bloco.chave} fundo={fundos[indice]} anterior={indice === 0 ? "white" : fundos[indice - 1]} proximo={fundos[indice + 1] || "contato"}>
            <Cabecalho rotulo={bloco.rotulo} titulo={bloco.titulo} texto={bloco.texto} claro={bloco.azul} />
            {bloco.conteudo}
          </Faixa>
        ))}
      </main>
      <Contact fundoAnterior={fundoFinal} />
      <Whatsapp />
      <Footer />
    </>
  );
};

export default PaginaLocal;
